import { useState, useEffect, useCallback } from "react";
import {
  getMediaTranscription,
  type MediaTranscription,
} from "../api/sopMedia";

export function useMediaTranscription(
  sopId: string | null,
  mediaId: string | null,
  options?: { skip?: boolean }
) {
  const [transcription, setTranscription] =
    useState<MediaTranscription | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTranscription = useCallback(async () => {
    if (!sopId || !mediaId || options?.skip) return;
    try {
      setLoading(true);
      setError(null);
      const data = await getMediaTranscription(sopId, mediaId);
      setTranscription(data);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to load transcription"
      );
      setTranscription(null);
    } finally {
      setLoading(false);
    }
  }, [sopId, mediaId, options?.skip]);

  useEffect(() => {
    fetchTranscription();
  }, [fetchTranscription]);

  return {
    transcription,
    loading,
    error,
    refetch: fetchTranscription,
  };
}
